<template>
  <div class="space-y-2">
    <div><ConfigHelpLabel label="文字内容" help-key="block_text_text" label-class="text-[10px] text-gray-500" tag="div" /><textarea v-model="block.data.text" @input="$emit('update')" rows="3" class="w-full px-2 py-1 border border-gray-300 rounded text-xs" placeholder="段落文字"></textarea></div>
    <div><ConfigHelpLabel label="对齐" help-key="block_text_align" label-class="text-[10px] text-gray-500" tag="div" /><select v-model="block.data.align" @change="$emit('update')" class="w-full px-2 py-1 border border-gray-300 rounded text-xs"><option value="center">居中</option><option value="left">左对齐</option><option value="right">右对齐</option></select></div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String] })
defineEmits(['update'])
onMounted(() => { if (!props.block.data) props.block.data = {}; if (!props.block.data.align) props.block.data.align = 'center' })
</script>
